import { useState, useEffect } from "react";
import { FiX } from "react-icons/fi";
import { createPortal } from "react-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useAuth } from "../../context/AuthContext"; // sesuaikan path

export default function FormDataKelas({ open, onClose, onSuccess, data }) {
  const { token } = useAuth(); // ← pakai session token

  const [namaKelas, setNamaKelas] = useState("");
  const [waliKelas, setWaliKelas] = useState("");
  const [jumlahSiswa, setJumlahSiswa] = useState("");
  const [loading, setLoading] = useState(false);

  /* ================= SET DATA EDIT ================= */
  useEffect(() => {
    if (data) {
      setNamaKelas(data.nama_kelas || "");
      setWaliKelas(data.wali_kelas || "");
      setJumlahSiswa(data.jumlah_siswa ?? "");
    } else {
      setNamaKelas("");
      setWaliKelas("");
      setJumlahSiswa("");
    }
  }, [data]);

  if (!open) return null;

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!namaKelas || !waliKelas || jumlahSiswa === "") {
      toast.error("Semua field wajib diisi");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        nama_kelas: namaKelas,
        wali_kelas: waliKelas,
        jumlah_siswa: Number(jumlahSiswa),
      };

      if (data) {
        // ===== UPDATE =====
        await axios.put(
          `https://backend.smpn1kamal.sch.id/api/kelas/${data.id_kelas}`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        toast.success("Kelas berhasil diperbarui");
      } else {
        // ===== CREATE =====
        await axios.post(
          "https://backend.smpn1kamal.sch.id/api/kelas",
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        toast.success("Kelas berhasil ditambahkan");
      }

      onSuccess();
      onClose();
    } catch (err) {
      console.error(err);
      toast.error("Gagal menyimpan data kelas");
    } finally {
      setLoading(false);
    }
  };

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 px-3">
      <div className="bg-white w-full sm:max-w-md rounded-xl shadow p-5 relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-slate-500 hover:text-red-500"
        >
          <FiX size={20} />
        </button>

        <h2 className="text-xl font-semibold mb-4 text-indigo-600">
          {data ? "Edit Kelas" : "Tambah Kelas"}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* NAMA KELAS */}
          <input
            type="text"
            placeholder="Nama Kelas"
            value={namaKelas}
            onChange={(e) => setNamaKelas(e.target.value)}
            className="w-full border rounded-lg px-3 py-2 text-sm"
          />

          {/* WALI KELAS */}
          <input
            type="text"
            placeholder="Nama Wali Kelas"
            value={waliKelas}
            onChange={(e) => setWaliKelas(e.target.value)}
            className="w-full border rounded-lg px-3 py-2 text-sm"
          />

          {/* JUMLAH SISWA */}
          <input
            type="number"
            min="0"
            placeholder="Jumlah Siswa"
            value={jumlahSiswa}
            onChange={(e) => setJumlahSiswa(e.target.value)}
            className="w-full border rounded-lg px-3 py-2 text-sm"
          />

          {/* ACTION */}
          <div className="flex justify-end gap-2 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border rounded-lg text-sm"
            >
              Batal
            </button>

            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 bg-indigo-500 text-white rounded-lg text-sm disabled:opacity-60"
            >
              {loading ? "Menyimpan..." : "Simpan"}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}